"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.SelfExclusionPeriod = exports.CoolingOffPeriod = exports.GameLimits = void 0;
var GameLimits_1 = require("./GameLimits");
Object.defineProperty(exports, "GameLimits", { enumerable: true, get: function () { return __importDefault(GameLimits_1).default; } });
var CoolingOffPeriod_1 = require("./CoolingOffPeriod");
Object.defineProperty(exports, "CoolingOffPeriod", { enumerable: true, get: function () { return __importDefault(CoolingOffPeriod_1).default; } });
var SelfExclusionPeriod_1 = require("./SelfExclusionPeriod");
Object.defineProperty(exports, "SelfExclusionPeriod", { enumerable: true, get: function () { return __importDefault(SelfExclusionPeriod_1).default; } });
